import { getCustomListControllerFetchCustomListsQueryOptions } from '@/api/generated/okami.ts'
import { CollectionListLoading } from '@/routes/_app/collections/-components/collection-list-loading.tsx'
import { CollectionList } from '@/routes/_app/collections/-components/collection-list.tsx'
import { CreateCollectionModal } from '@/routes/_app/collections/-components/create-collection-modal.tsx'
import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'

export const Route = createFileRoute('/_app/collections/')({
  component: Collections,
  loader: async ({ context }) =>
    context.queryClient.ensureQueryData(getCustomListControllerFetchCustomListsQueryOptions()),
  head: () => ({
    meta: [
      {
        title: 'Suas Coleções | Okami',
      },
    ],
  }),
})

function Collections() {
  return (
    <div className=" flex flex-col gap-4">
      <aside className="flex flex-col justify-center items-center gap-2 md:flex-row  md:justify-between">
        <h1 className="text-center text-3xl font-bold tracking-tighter md:text-left">Suas coleções</h1>

        <div className="flex justify-center gap-2 ">
          <CreateCollectionModal />
        </div>
      </aside>

      <Suspense fallback={<CollectionListLoading />}>
        <div className="grid gap-4 grid-cols-[repeat(auto-fill,minmax(350px,1fr))]">
          <CollectionList />
        </div>
      </Suspense>
    </div>
  )
}
